<template>
  <div>
    <button
      id="id-assign-convo-btn"
      type="button"
      class="btn btn-rounded btn-block mt-1 btn-success"
      :disabled="httpPending"
      @click.prevent="assignConversation()"
    >
      <i v-if="httpPending" class="fa fa-spinner fa-spin"></i>
      Assign Myself
    </button>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters,mapState } from "vuex";

export default {
  props: {
    conversationId: String
  },
  data() {
    return {
      httpPending: false,
    };
  },
  computed: {
    ...mapGetters("agency", ["currentAgencyId"]),
    ...mapState({
      path: (state) => state.connection.path,
      currentUser: (state) => state.user.user,
      currentToken: (state) => state.user.token
    }),
  },
  methods: {
    async assignConversation() {
      this.httpPending = true;
      try {
        const resp = await this.$ConveyApi.conversationsApi.assignAgentToConversation({
          conversationId: this.conversationId,
          userId: this.currentUser.user_id,
        });

        if (resp.status <= 200) {
          if (resp.status == 200) {
            this.$toastr("success", "Conversation Assigned");
          }
          this.httpPending = false;
          return true;
        } else {
          this.$toastr("error", "Error Assigning Conversation (" + resp.status + ")", resp.data.error);
          this.httpPending = false;
          return false;
        }
      } catch (error) {
        this.$toastr("error", "Error Assigning Conversation");
        this.httpPending = false;
        return false;
      }
    }
  }
};
</script>
